export const onGetMiddlePages = (chosenPage: number, maxPages: number, pages: number[]): number[] | null => {
    if (chosenPage >= maxPages - 1 && chosenPage <= pages[pages.length - maxPages + 1]) {
        return [chosenPage - 2, chosenPage - 1, chosenPage]
    }
    return null
}
